import React, { useEffect, useState } from 'react'
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { enumUtil } from '../../../utils/Enum';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import { PDF, Textfile } from '../../shared/IconsComponent/icons';
const GroupMedia = ({ receiverUserID }) => {

    const API_URL_Messages = enumUtil.controller.Messages
    const [isLoading, setisLoading] = useState(false)
    const [images, setImages] = useState([])
    const [documents, setDocuments] = useState([])
    useEffect(() => {
        ServerRequestProtected(API_URL_Messages + "/GetChatMedia", 'post', {
            'TableName': enumUtil.enumAPITableName.Messages,
            'SearchCriteria': {
                'ReceiverID': receiverUserID + "",
            },
        }).then((response) => {
            setImages(response.images)
            setDocuments(response.documents)
            setisLoading(false)

        }).catch((error) => {
            setisLoading(false)
            NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }, [])
    const getFileIcon = (fileName) => {
        const extension = fileName?.split('.').pop()?.toLowerCase();
        switch (extension) {
            case 'pdf': return <PDF classes={'fs-30'} />;
            case 'xls':
            case 'xml':
            case 'xlsx': return <i className='icon-excel fs-30 text-success'></i>;
            case 'doc':
            case 'docx': return <span class="icon-word fs-28"><span class="path1"></span><span class="path2"></span><span class="path3"></span></span>;
            case 'jpg':
            case 'jpeg':
            case 'png': return <i className='icon-image fs-30'></i>;
            default: return <Textfile classes={'fs-30'} />;
        }
    };
    return (
        <div className='za-new-conversation-screen group-media pb-0 bg-transparent'>
            {/* {isLoading ? <Loader /> : null} */}
            {/* <div className='d-flex gap-1 align-items-center za-header'>
                <span className='icon-box d-flex align-items-center justify-content-center'><i className='icon-arrow-left2'></i></span>
                <p className='heading fs-14'>EMS Design Testing Hub</p>
            </div> */}

            {/* <div className="image-preview">
                <div className="image-preview-content">
                    <div className="d-flex align-items-center justify-content-between gap-10 pb-2">
                        <p className='text drk-clr'>Image.png</p>
                        <div className="d-flex align-items-center gap-1">
                            <i className="icon-new-download fs-15"></i>
                            <i className="icon-x-cros fs-20 dark-clr fw-900"></i>
                        </div>
                    </div>
                    <img src={''} alt="" />
                </div>
            </div> */}
            <div className='za-content mt-10'>
                <Tab.Container defaultActiveKey="media">
                    <div className="">
                        <Nav variant="tabs" className="d-flex justify-content-between align-items-center mb-10 px-10">
                            <Nav.Item>
                                <Nav.Link eventKey="media" className="nav-item heading fs-12 br-bottom-4px ar-light-color pe-4"> Media</Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link eventKey="docs" className="nav-item heading fs-12 br-bottom-4px ar-light-color pe-4">Docs</Nav.Link>
                            </Nav.Item>
                            {/* <Nav.Item>
                                <Nav.Link eventKey="links" className="nav-item heading fs-12 br-bottom-4px ar-light-color pe-4">Links</Nav.Link>
                            </Nav.Item> */}
                        </Nav>
                    </div>
                    <Tab.Content>
                        {/* <div className="ar-small-loader justify-content-center last_loader">
                            <div className="circle circle1"></div>
                            <div className="circle circle2"></div>
                        </div> */}
                        <Tab.Pane eventKey="media">
                            <div className="za-media">
                                <div className='hover-scrollbar d-flex flex-wrap gap-2'>
                                    {images.length > 0 ?
                                        images.map((item, index) => {
                                            return (
                                                <div className='za-media-card' key={index}>
                                                    <img src={item.mediaLink} alt="" />
                                                </div>
                                            )
                                        })
                                        : null}
                                </div>
                            </div>
                        </Tab.Pane>
                        <Tab.Pane eventKey="docs">
                            <div className='d-flex flex-column  hover-scrollbar row-gap-5 za-cards za-media'>
                                {documents?.length > 0 && documents.map((item, index) => {
                                    return (
                                        <div key={index}
                                            className='za-card d-flex justify-content-between align-items-center cursor-pointer'
                                            onClick={() => window.open(item.mediaLink, '_blank')}
                                            title="Open document"
                                        >
                                            <div className='za-guidelines-new d-flex justify-content-center align-items-center gap-1 mt-2'>
                                                <div>
                                                    {getFileIcon(item.mediaName)}
                                                    {/* 
                                                    <span className="icon-pdf-chatbot fs-30">
                                                        <span className="path1"></span>
                                                        <span className="path2"></span>
                                                        <span className="path3"></span>
                                                        <span className="path4"></span>
                                                        <span className="path5"></span>
                                                        <span className="path6"></span>
                                                        <span className="path7"></span>
                                                    </span> */}
                                                </div>
                                                <div>
                                                    <div className='col-12'>
                                                        <p className='text font-m fs-13'>{item.mediaName?.split('.')[0]}</p>
                                                    </div>
                                                    <div className='d-flex'>
                                                        <div className='col-md-8'>
                                                            <p className='text fs-10 text-start'>18MB</p>
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <p className='text fs-10'>{item.mediaName?.split('.')[1]}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='text fs-11'>{item.createdDate}</p>
                                        </div>)
                                })}
                            </div>
                        </Tab.Pane>
                        {/* <Tab.Pane eventKey="links">
                            <div className='d-flex flex-column  hover-scrollbar row-gap-5 za-cards za-media'>
                                <div className='za-card'>
                                    <i className='icon-Group-8511 fs-10'></i>
                                    <div className=''>
                                        <p className='text font-m za-blue-clr'>https://ems.theeasyedi.com/#/ems</p>
                                        <p className='text '>11:46 PM</p>
                                    </div>
                                </div>

                                <div className='za-card'>
                                    <i className='icon-Group-8511 fs-10'></i>
                                    <div className=''>
                                        <p className='text font-m za-blue-clr'>https://ems.theeasyedi.com/#/ems</p>
                                        <p className='text '>11:46 PM</p>
                                    </div>
                                </div>

                                <div className='za-card'>
                                    <i className='icon-Group-8511 fs-10'></i>
                                    <div className=''>
                                        <p className='text font-m za-blue-clr'>https://ems.theeasyedi.com/#/ems</p>
                                        <p className='text '>11:46 PM</p>
                                    </div>
                                </div>

                            </div>
                        </Tab.Pane> */}
                    </Tab.Content>
                </Tab.Container>

            </div>
        </div>

    )
}

export default GroupMedia